import { Injectable } from '@angular/core';

export type AOA = any[][]; // Array of Array (for Excel Export)

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  constructor() {}

  public convertJSONObjectArrayToAOA(jsonObjectArray: any[], columnsList: string[]): AOA {
    const aoa: AOA = [];
    for (const item of jsonObjectArray) {
      const dataArray: any[] = [];
      for (const column of columnsList) {
        dataArray.push(item[column]);
      }
      aoa.push(dataArray.slice());
    }
    return aoa.slice();
  }

  public rot47(inputString: string): string {
    let encodedString = '';
    for (let i = 0; i < inputString.length; i++) {
      const inputCharCode = inputString.charCodeAt(i);
      if (inputCharCode >= 33 && inputCharCode <= 126) {
        encodedString += String.fromCharCode(33 + ((inputCharCode + 14) % 94));
      } else {
        encodedString += String.fromCharCode(inputCharCode);
      }
    }
    return encodedString;
  }
}
